<template>
  <app-timeline>

    <!-- 12 INVOICES HAVE BEEN PAID -->
    <app-timeline-item target-icon="AlertCircleIcon   ">
      <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
        <h6>A Firması</h6>
        <small class="text-muted">1 Hafta Önce</small>
      </div><br>
      <b-button
        v-b-toggle.report-list-with-icon
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        size="sm"
        variant="outline-primary"
      >
        Görüntüle
      </b-button>

      <b-collapse id="report-list-with-icon">
        <b-list-group
          flush
          class="mt-1"
        />
        <div>
          <b-form-select
            v-model="selected"
            :options="options"
          />

        </div><br>
        <tablo-2 />
      </b-collapse>

    </app-timeline-item>

    <!-- DESIGNING UI -->
  </app-timeline>
</template>

<script>
import {
  BButton, BCollapse, VBToggle, BListGroup, VBTooltip, BFormSelect,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import Tablo2 from './Tablo2.vue'

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    Tablo2,
    BButton,
    BFormSelect,
    BCollapse,
    BListGroup,

  },
  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
}
</script>
